<template>
  <div>
    <!-- 头部开始 -->
    <div class="header">
      <div class="content">
        <div class="home">
          <router-link to="/">
            <span class="icon-home"></span>
            <span>返回首页</span>
          </router-link>
        </div>
        <div class="user">
          <div class="user-avatar">
            <img
              style="height: 100%; border-radius: 50%"
              :src="userInfo.headImage"
              alt=""
            />
          </div>
          <div class="user-name">
            <span>
              {{ userInfo.account ? userInfo.account : userInfo.name }}
            </span>
            <span>商家工作台</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 头部结束 -->
    <!-- 内容主体开始 style="width: 100%; height: 674px"-->
    <div class="main">
      <img
        v-if="isShowImage"
        src="../../assets/images/shopIntr/shop/2560bgbanner@2x.png"
        alt=""
        class="img2560"
      />
      <img
        v-else
        src="../../assets/images/shopIntr/shop/bgbanner@2x.png"
        alt=""
        class="img1920"
      />
      <div class="logo">
        <img src="../../assets/images/shopIntr/shop/logo@2x.png" alt="" />
        <span>招商</span>
        <img src="../../assets/images/shopIntr/shop/huo@2x.png" alt="" />
      </div>
      <div class="tabs">
        <div :class="active ? 'active' : ''" @click="active = true">
          一键开店
        </div>
        <div :class="active ? '' : 'active'" @click="active = false">
          常见问题
        </div>
      </div>
      <div class="btns">
        <div @click="skpiRouter">我要开店></div>
        <div>供应商入驻></div>
      </div>
    </div>
    <!-- 内容主体结束 -->
    <!-- 变换内容一开始 -->
    <div v-if="active">
      <!-- icon文字开始 -->
      <div class="iconText">
        <div>
          <img src="../../assets/images/shopIntr/shop/menkan@2x.png" alt="" />
          <p>门槛低</p>
          <p>线上申请流程快</p>
        </div>
        <div>
          <img src="../../assets/images/shopIntr/shop/kaidian@2x.png" alt="" />
          <p>一键开店</p>
          <p>省钱省心省力</p>
        </div>
        <div>
          <img src="../../assets/images/shopIntr/shop/zhouqi@2x.png" alt="" />
          <p>结算周期短</p>
          <p>资金直接进入商家账户</p>
        </div>
        <div>
          <img src="../../assets/images/shopIntr/shop/jinrong@2x.png" alt="" />
          <p>金融赋能</p>
          <p>信用变财富生意更轻松</p>
        </div>
      </div>
      <!-- icon文字结束 -->
      <!-- 流程图开始 -->
      <div class="flow">
        <div class="title">
          <img src="../../assets/images/shopIntr/shop/liuchen@2x.png" alt="" />
        </div>
        <img src="../../assets/images/shopIntr/shop/liucheng@2x.png" alt="" />
      </div>
      <!-- 流程图结束 -->
      <!-- 卡片开始 -->
      <div class="card">
        <div>
          <img src="../../assets/images/shopIntr/shop/quanyi@2x.png" alt="" />
        </div>
        <div>
          <img src="../../assets/images/shopIntr/shop/banner1@2x.png" alt="" />
          <img src="../../assets/images/shopIntr/shop/banner2@2x.png" alt="" />
        </div>
      </div>
      <!-- 卡片结束 -->
    </div>
    <!-- 变换内容一结束 -->
    <!-- 变换内容二开始 -->
    <div v-else>
      <!-- iconText开始 -->
      <div class="iconText2">
        <div>
          <img src="../../assets/images/shopIntr/issue/bangzhu@2x.png" alt="" />
          <p>帮助中心</p>
          <p>自助进行问题学习解决</p>
        </div>
        <div>
          <img src="../../assets/images/shopIntr/issue/kefu@2x.png" alt="" />
          <p>智能客服</p>
          <p>商家端智能服务助手</p>
        </div>
        <div>
          <img src="../../assets/images/shopIntr/issue/peixun@2x.png" alt="" />
          <p>培训中心</p>
          <p>即时在线学习热门课程</p>
        </div>
      </div>
      <!-- iconText结束 -->
      <!-- 热门问题开始 -->
      <div class="hot">
        <div class="title">
          <img src="../../assets/images/shopIntr/issue/remen@2x.png" alt="" />
        </div>
        <div class="contents">
          <div
            @mouseleave="show = ''"
            @mouseover="show = 1"
            :class="show == 1 ? 'hover' : ''"
          >
            <img
              v-show="show != 1"
              src="../../assets/images/shopIntr/issue/ruzhu@2x.png"
              alt=""
            />
            <img
              v-show="show == 1"
              src="../../assets/images/shopIntr/issue/ruzhuHeight@2x.png"
              alt=""
            />
            <p>招商入驻</p>
          </div>
          <div
            @mouseleave="show = ''"
            @mouseover="show = 2"
            :class="show == 2 ? 'hover' : ''"
          >
            <img
              v-show="show != 2"
              src="../../assets/images/shopIntr/issue/zhuangxiu@2x.png"
              alt=""
            />
            <img
              v-show="show == 2"
              src="../../assets/images/shopIntr/issue/dianpuHeight@2x.png"
              alt=""
            />
            <p>店铺装修</p>
          </div>
          <div
            @mouseleave="show = ''"
            @mouseover="show = 3"
            :class="show == 3 ? 'hover' : ''"
          >
            <img
              v-show="show != 3"
              src="../../assets/images/shopIntr/issue/weifa@2x.png"
              alt=""
            />
            <img
              v-show="show == 3"
              src="../../assets/images/shopIntr/issue/weifaHeight@2x.png"
              alt=""
            />
            <p>违法处罚</p>
          </div>
          <div
            @mouseleave="show = ''"
            @mouseover="show = 4"
            :class="show == 4 ? 'hover' : ''"
          >
            <img
              v-show="show != 4"
              src="../../assets/images/shopIntr/issue/huodong@2x.png"
              alt=""
            />
            <img
              v-show="show == 4"
              src="../../assets/images/shopIntr/issue/huodongHeight@2x.png"
              alt=""
              style="margin-left: -1px"
            />
            <p>营销活动</p>
          </div>
        </div>
        <!-- 热门问题弹窗开始 -->
        <div class="boxHover">
          <div v-show="show == 1" @mouseleave="show = ''" @mouseover="show = 1">
            <ul>
              <li>小黄牛招商类目一览表</li>
              <li>招商联系方式</li>
              <li>店铺名称命名规格</li>
              <li>为什么商家对公账户认证要转钱</li>
              <li>小黄牛2021收费一览表</li>
              <li>运营联系方式</li>
              <li>入住流程1</li>
            </ul>
          </div>
          <div v-show="show == 2" @mouseleave="show = ''" @mouseover="show = 2">
            <ul>
              <li>小黄牛招商类目一览表</li>
              <li>招商联系方式</li>
              <li>店铺名称命名规格</li>
              <li>为什么商家对公账户认证要转钱</li>
              <li>小黄牛2021收费一览表</li>
              <li>运营联系方式</li>
              <li>入住流程1</li>
            </ul>
          </div>
          <div v-show="show == 3" @mouseleave="show = ''" @mouseover="show = 3">
            <ul>
              <li>小黄牛招商类目一览表</li>
              <li>招商联系方式</li>
              <li>店铺名称命名规格</li>
              <li>为什么商家对公账户认证要转钱</li>
              <li>小黄牛2021收费一览表</li>
              <li>运营联系方式</li>
              <li>入住流程1</li>
            </ul>
          </div>
          <div v-show="show == 4" @mouseleave="show = ''" @mouseover="show = 4">
            <ul>
              <li>小黄牛招商类目一览表</li>
              <li>招商联系方式</li>
              <li>店铺名称命名规格</li>
              <li>为什么商家对公账户认证要转钱</li>
              <li>小黄牛2021收费一览表</li>
              <li>运营联系方式</li>
              <li>入住流程1</li>
            </ul>
          </div>
        </div>
        <!-- 热门问题弹窗结束 -->
      </div>
      <!-- 热门问题结束 -->
      <!-- 公告开始 -->
      <div class="notice">
        <div>
          <img src="../../assets/images/shopIntr/issue/gonggao@2x.png" alt="" />
        </div>
        <div class="box">
          <div>
            <div>
              <img :src="imagesUrl" alt="" />
            </div>
            <div class="text">
              <p>“国家营养餐试点”的食品安全如何守护？</p>
              <p>
                2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农
              </p>
            </div>
          </div>

          <div>
            <div>
              <img :src="imagesUrl" alt="" />
            </div>
            <div class="text">
              <p>“国家营养餐试点”的食品安全如何守护？</p>
              <p>
                2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农
              </p>
            </div>
          </div>

          <div>
            <div>
              <img :src="imagesUrl" alt="" />
            </div>
            <div class="text">
              <p>“国家营养餐试点”的食品安全如何守护？</p>
              <p>
                2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农
              </p>
            </div>
          </div>

          <div>
            <div>
              <img :src="imagesUrl" alt="" />
            </div>
            <div class="text">
              <p>“国家营养餐试点”的食品安全如何守护？</p>
              <p>
                2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农2011年，中央决定从秋季学期起，启动农
              </p>
            </div>
          </div>
        </div>
        <div class="more">更多公告</div>
      </div>
      <!-- 公告结束 -->
    </div>
    <!-- 变换内容二结束 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Footer from "@/components/base/footer";
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
import { BASEURL_PRO_ENTERPRISE } from "../../modules/http";
// 测试
import imagesUrl from "@/assets/images/avatar.png";

export default {
  mixins: [listSearchMixin],
  components: {
    Footer,
  },
  data() {
    return {
      // 测试
      imagesUrl,
      active: true,
      show: "",
      isShowImage: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.showImage();
  },
  methods: {
    showImage() {
      if (window.screen.width > 1920) {
        this.isShowImage = true;
      }
    },
    skpiRouter() {
      let params = {
        url: api.checkState,
        method: "POST",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      this.sendReq(params, (res) => {
        if(res.code == 200){
          const { checkState, shopId } = res.data;
          if (checkState == 1) {
            let params = {
              url: api.scopeList,
              method: "post",
              data: {
                shopId
              }
            }
            this.sendReq(params, (res) => {
              let arr = res.data.map(item => item.scopeId || 'hello world');
              if(arr.includes(2)){
                this.$message.success("正在为您跳转后台...");
                setTimeout(() => {
                  window.open(BASEURL_PRO_ENTERPRISE);
                }, 2000);
              } else {
                let params = {
                  url: api.getShopApply,
                  method: "POST",
                  data: {
                    shopId,
                    scopeId: 2
                  },
                }
                this.sendReq(params, (res) => {
                  if(res.data.checkHandle == -1){
                    return this.$message.warning("大宗集采业务申请待审核");

                  }else if(res.data.checkHandle == 0){
                    return this.$message.error("大宗集采业务申请被拒绝，请联系平台客服");
                    
                  }else{
                    this.$confirm({
                      title: "您已成功入驻小黄牛供应链平台!",
                      content: (h) => {
                        return (
                          <div style="font-size:15px">
                            店铺已开通，现在需要申请开通大宗集采商城业务吗？
                          </div>
                        );
                      },
                      icon: "check-circle",
                      width: 600,
                      cancelText: "取消",
                      okText: "申请",
                      okType: "danger",
                      onOk: () => {
                        let params = {
                          url: api.scopeApply,
                          method: "post",
                          data: {
                            shopId,
                            scopeId: 2
                          }
                        }
                        this.sendReq(params, (res) => {
                          if(res.code == 200) return this.$message.success("申请成功！请等待平台审核");

                          this.$message.warning("大宗集采业务申请待审核");
                        })
                      },
                    });
                  }
                });
              }
            })

          }else {
            this.$router.push("/shopData");
          }

        }else {
          this.$router.push("/shopData");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 46px;

  .content {
    width: 1530px;
    height: 100%;
    display: flex;
    background: none !important;
    justify-content: space-between;
    margin: 0 auto;

    .home {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #666666;
      line-height: 46px;

      .router-link-active:hover {
        color: #fe8b3e;
      }
    }

    .user {
      display: flex;
      height: 100%;
      line-height: 46px;

      .user-avatar {
        width: 32px;
        height: 32px;
      }

      .user-name {
        margin-left: 6px;

        > :last-child {
          margin-left: 52px;
        }
      }
    }
  }
}

.main {
  width: 100%;
  position: relative;

  > .logo {
    position: absolute;
    top: 34px;
    left: 151px;

    > img:first-of-type {
      width: 305px;
      height: 67px;
    }

    > span {
      font-size: 18px;
      font-family: MicrosoftYaHei;
      color: #a85810;
      line-height: 24px;
      margin-left: 22px;
      padding-left: 18px;
      padding-right: 7px;
      border-left: 1px solid #dfdcdc;
    }

    > img:last-of-type {
      width: 18px;
      height: 21px;
      margin-top: -5px;
    }
  }

  > .img2560 {
    width: 100%;
    height: 674px;
    object-fit: cover;
  }

  > .img1920 {
    width: 100%;
    height: 502px;
    object-fit: cover;
  }

  .tabs {
    position: absolute;
    top: 44px;
    right: 149px;
    display: flex;

    // 选中样式
    .active {
      font-weight: bold;
    }

    > div {
      font-size: 18px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      line-height: 24px;
      padding-bottom: 16px;
      cursor: pointer;
    }

    > div:last-of-type {
      margin-left: 53px;
    }
  }

  .btns {
    position: absolute;
    right: 553px;
    bottom: 54px;
    display: flex;

    > div {
      width: 131px;
      height: 55px;
      border-radius: 32px;
      line-height: 55px;
      text-align: center;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      cursor: pointer;
    }

    > :first-of-type {
      background: #f77b0b;
    }

    > :last-of-type {
      border: 1px solid #f77b0b;
      color: #f77b0b;
      margin-left: 18px;
      background-color: #ffffff;
    }
  }
}

// 变换内容一
.iconText {
  width: 1175px;
  display: flex;
  margin: 148px auto 0 auto;
  justify-content: space-between;

  > div {
    text-align: center;

    img {
      width: 70px;
      height: 70px;
    }
    :nth-child(2) {
      font-size: 22px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #000000;
      line-height: 29px;
      margin-top: 13px;
    }

    :nth-child(3) {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #606266;
      line-height: 21px;
      margin-top: 17px;
    }
  }
}

.flow {
  width: 1175px;
  margin: 135px auto 0 auto;

  > .title {
    text-align: center;

    > img {
      width: 110px;
      height: 36px;
    }
  }

  > img {
    margin-top: 50px;
    width: 1172px;
    height: 170px;
  }
}

.card {
  width: 1175px;
  margin: 135px auto 0 auto;

  > :first-child {
    text-align: center;

    > img {
      width: 404px;
      height: 35px;
    }
  }

  > :last-child {
    margin-top: 42px;
    margin-bottom: 76px;
    font-size: 0;

    > img {
      width: 575px;
      height: 240px;
    }

    > img:last-of-type {
      margin-left: 25px;
    }
  }
}

// 变换内容二
.iconText2 {
  width: 1175px;
  margin: 115px auto 0 auto;
  display: flex;
  justify-content: space-between;

  > div {
    text-align: center;

    > img {
      width: 88px;
      height: 88px;
    }

    > p:first-of-type {
      font-size: 26px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #000000;
      line-height: 35px;
      margin-top: 16px;
    }

    > p:last-of-type {
      font-size: 18px;
      font-family: MicrosoftYaHei;
      color: #606266;
      line-height: 24px;
      margin-top: 20px;
    }
  }
}

.hot {
  width: 1175px;
  margin: 124px auto 0 auto;

  .title {
    text-align: center;

    > img {
      width: 110px;
      height: 36px;
    }
  }

  .contents {
    margin-top: 40px;
    display: flex;
    background-color: none !important;

    justify-content: space-between;

    .hover {
      border-bottom: 3px solid #f77b0b;
      cursor: pointer;
    }

    > div {
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 3px solid transparent;

      > img {
        width: 64px;
        height: 64px;
      }

      > p {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: #000000;
        line-height: 26px;
        margin-top: 14px;
      }
    }

    > div:first-of-type {
      position: relative;
      left: 90px;
      margin-left: -32px;
    }

    > div:last-of-type {
      position: relative;
      right: 90px;
      margin-right: -32px;
    }

    > div:nth-child(2) {
      margin-left: 58px;
    }

    > div:nth-child(3) {
      margin-right: 58px;
    }
  }

  .boxHover {
    position: relative;
    display: flex;
    justify-content: space-between;

    > div {
      position: absolute;
      width: 366px;
      height: 290px;
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(231, 234, 235, 0.93);
      border-radius: 4px;
      box-sizing: border-box;
      padding: 18px 88px 16px 48px;

      > ul {
        list-style-type: disc;

        > li {
          margin-top: 10px;
        }
      }
    }

    > div:nth-child(1) {
      margin-left: 80px;
      left: -163px;
    }

    > div:nth-child(2) {
      left: 25%;
      margin-left: -63px;
    }

    > div:nth-child(3) {
      right: 25%;
      margin-right: -63px;
    }

    > div:nth-child(4) {
      margin-right: 80px;
      right: -163px;
    }
  }
}

.notice {
  width: 1175px;
  margin: 121px auto 0 auto;

  > div:first-of-type {
    text-align: center;

    > img {
      width: 110px;
      height: 36px;
    }
  }

  .box {
    margin-top: 48px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    > div {
      display: flex;
      width: 520px;

      > div:not(div:nth-child(1), div:nth-child(2)) {
        margin-top: 50px;
      }

      > div {
        > img {
          width: 100px;
          height: 100px;
        }
      }
    }

    > div {
      > .text {
        margin-left: 34px;

        > p:first-of-type {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #262f47;
          line-height: 26px;
        }

        > p:last-of-type {
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: #606266;
          line-height: 26px;
          margin-top: 11px;
          margin-left: 11px;
          margin-right: 11px;
          // 超出两行显示省略号
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .text:hover {
        cursor: pointer;

        > p {
          color: #f77b0b;
        }
      }
    }
  }

  .more {
    width: 104px;
    height: 39px;
    border-radius: 4px;
    border: 1px solid #f77b0b;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #f77b0b;
    line-height: 26px;
    text-align: center;
    line-height: 39px;
    margin: 65px auto 37px auto;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/shopInfr/index.vue